/**
 * Logs source tracking parameters for analytics and debugging.
 * This helps identify possible duplicate report events for LinkedIn visits.
 * Logs only once per page load to avoid excessive logging.
 */
const LOGGED_FLAG = '__sourceTrackingLogged';

interface WindowWithTrackingFlag extends Window {
  [LOGGED_FLAG]?: boolean;
}

export function logSourceTrackingParams(
  queryParams: URLSearchParams,
  cookieParams: URLSearchParams,
  resolvedSource: string,
): void {
  // Log only once per page load to avoid excessive logging
  const windowWithFlag = window as WindowWithTrackingFlag;
  if (windowWithFlag[LOGGED_FLAG]) {
    return;
  }
  windowWithFlag[LOGGED_FLAG] = true;

  const queryRxSource = queryParams.get('rx_source') ?? null;
  const queryUtmSource = queryParams.get('utm_source') ?? null;
  const cookieRxSource = cookieParams.get('rx_source') ?? null;
  const cookieUtmSource = cookieParams.get('utm_source') ?? null;

  const logData = {
    timestamp: new Date().toISOString(),
    url: window.location.href,
    queryParams: {
      rx_source: queryRxSource,
      utm_source: queryUtmSource,
      rx_campaign: queryParams.get('rx_campaign') ?? null,
      utm_campaign: queryParams.get('utm_campaign') ?? null,
    },
    cookieParams: {
      rx_source: cookieRxSource,
      utm_source: cookieUtmSource,
      utm_campaign: cookieParams.get('utm_campaign') ?? null,
    },
    resolvedSource,
    sourceResolution: {
      fromQueryRxSource: queryRxSource !== null,
      fromCookieUtmSource: queryRxSource === null && cookieUtmSource !== null,
      fromCookieRxSource:
        queryRxSource === null && cookieUtmSource === null && cookieRxSource !== null,
      fromNone: queryRxSource === null && cookieUtmSource === null && cookieRxSource === null,
    },
  };

  // eslint-disable-next-line no-console
  console.log('[Source Tracking]', JSON.stringify(logData, null, 2));
}
